export default {
  mounted(el: any, binding: any) {
    const {value} = binding
    const clickOutsideHandler = (e: any) => {
      if (!e.path.includes(el)) value()
    }
    el.__clickOutsideHandler = clickOutsideHandler
    document.body.addEventListener('click', clickOutsideHandler)
  },
  unmounted(el: any) {
    document.body.removeEventListener('click', el.__clickOutsideHandler)
  }
}
